import { NgModule } from '@angular/core';
import { OptionModule } from '../abstract/option.module';
import { OptionTextComponent } from './option-text.component';
import { AutosizeModule } from 'ngx-autosize';
// import {Autosize} from 'ng-autosize';
import { FormsModule } from '@angular/forms';
import { NgModelOptionsModule } from '../../../../shared';

@NgModule({
  imports: [
    OptionModule, 
    AutosizeModule, 
    // Autosize,
    FormsModule, 
    NgModelOptionsModule],
  declarations: [OptionTextComponent],
  exports: [OptionTextComponent]
})
export class OptionTextModule {}
